import { FormattedMessage } from "react-intl";
import useSearchOutletContext from "../layout/outletContext.ts";
import ResultsTemplate from "../common/ResultsTemplate.tsx";
import { useCallback, useRef, useState } from "react";
import ContentResultsPanel from "./ContentResultsPanel.tsx";
import { useSearchParams } from "react-router-dom";
import { getSearchQuery } from "../query.ts";
import GridResultCard from "./GridResultCard.tsx";
import styles from "./SearchCountsResults.module.scss";
import { ManageAssetWithLicense } from "../../../../common/api/decimal/common-types/manageAssets.ts";
import FavoritesResults from "./FavoritesResults.tsx";
import AllContentResults from "./all-content-results/AllContentResults.tsx";
import { makeSearchReturnDetail, SearchSection } from "./types.ts";
import useReaderSearchReturn from "../common/useReaderSearchReturn.ts";

interface SectionedResultAsset {
  asset: ManageAssetWithLicense;
  section: SearchSection;
}

export default function SearchCountsResults() {
  const {
    contentResults: { allResults, recentResults, nextCursor, status },
  } = useSearchOutletContext();
  const [sectionedResultsAsset, setSectionedResultsAsset] =
    useState<SectionedResultAsset>();
  const [searchParams] = useSearchParams();
  const query = getSearchQuery(searchParams);
  const containerRef = useRef<HTMLDivElement>(null);
  const setActiveResult = useCallback(
    (asset: ManageAssetWithLicense, section: SearchSection) => {
      setSectionedResultsAsset({ asset, section });
    },
    []
  );
  useReaderSearchReturn(containerRef);

  return (
    <ResultsTemplate
      isLoading={status === "loading"}
      isEmpty={status === "empty"}
    >
      <div ref={containerRef} className={styles.container}>
        {recentResults.length > 0 && (
          <div>
            <FormattedMessage
              defaultMessage="Content Results in Recent Activity"
              tagName="h2"
            />
            <ul className={styles.list}>
              {recentResults?.map((result, index) => (
                <GridResultCard
                  searchResult={result}
                  openPanel={setActiveResult}
                  key={result.asset.manageAsset.vbid}
                  dynamicStyles={{ zIndex: -index }}
                  section={"recent"}
                  libraryReturn={makeSearchReturnDetail(
                    "recent",
                    result.asset.manageAsset.vbid
                  )}
                />
              ))}
            </ul>
          </div>
        )}
        <FavoritesResults openPanel={setActiveResult} />
        {allResults && (
          <AllContentResults
            initialResults={allResults}
            initialNextCursor={nextCursor}
            openPanel={setActiveResult}
          />
        )}
      </div>
      {sectionedResultsAsset && (
        <ContentResultsPanel
          key={sectionedResultsAsset.asset.manageAsset.vbid}
          initialQuery={query}
          asset={sectionedResultsAsset.asset.manageAsset}
          license={sectionedResultsAsset.asset.license}
          section={sectionedResultsAsset.section}
          onRequestClose={() => setSectionedResultsAsset(undefined)}
        />
      )}
    </ResultsTemplate>
  );
}
